export default __webpack_public_path__ + "static/media/crop-active.7c42a9e0.svg";